import {useEffect, useRef} from 'react'
import Copilot from './assets/cta-universe/cta-universe-copilot.webp'
import Mona from './assets/cta-universe/cta-universe-mona.webp'
import Ducky from './assets/cta-universe/cta-universe-ducky.webp'
import CtaButterfly from './components/Butterfly/CtaButterfly'
export default function IntroHeroUniverse() {
  const mascotsRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (prefersReducedMotion) {
      return
    }

    if (!mascotsRef.current) return

    mascotsRef.current.classList.add('beforeAnimate')

    const observer = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            if (mascotsRef.current) {
              mascotsRef.current.classList.add('animate')
            }
            observer.disconnect()
          }
        }
      },
      {threshold: 0.5},
    )

    observer.observe(mascotsRef.current)

    return () => {
      observer.disconnect()
    }
  }, [])
  return (
    <div className="lp-Cta-mascots-universe" ref={mascotsRef}>
      <div className="lp-Cta-mascots-universe-Glow">
        <div />
        <div />
        <div />
        <div />
      </div>
      <div className="lp-Cta-mascots-universe-Ducky">
        <img src={Ducky} alt="" aria-hidden="true" />
      </div>
      <div className="lp-Cta-mascots-universe-Mona">
        <img src={Mona} alt="" aria-hidden="true" />
      </div>
      <div className="lp-Cta-mascots-universe-Copilot">
        <img src={Copilot} alt="" aria-hidden="true" />
      </div>
      <CtaButterfly />
    </div>
  )
}

try{ IntroHeroUniverse.displayName ||= 'IntroHeroUniverse' } catch {}